"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVariableMetadataObject = void 0;
// (C) 2020 GoodData Corporation
var types_1 = require("../types");
/**
 * Tests whether the provided object is of type {@link IVariableMetadataObject}.
 *
 * @param obj - object to test
 * @public
 */
function isVariableMetadataObject(obj) {
    return types_1.isMetadataObject(obj) && obj.type === "variable";
}
exports.isVariableMetadataObject = isVariableMetadataObject;
//# sourceMappingURL=index.js.map